import {SAVE_PRATICAL_SHEETS, SEARCH_SHEETS} from "../actions/sheets";

export const initialState = {
    sheetsList: [],
    searchSheetValue: "",
    searchSheet: [],
    firstsSheetsOfArray: []
};

const sheets = (state = initialState, action = {}) => {
    switch (action.type) {
        case SAVE_PRATICAL_SHEETS : {
            let n = 3; // Correspond au 3 fiches pratiques affiché par défaut sur la page Home
            // Ici on choisit trois fiches aléatoirement pour les stocker dans une variable qui contiendra uniquement
            // trois fiches pratiques.
            const firstsSheetsOfArray = action.sheets.sort(() => Math.random() - Math.random()).slice(0, n);
            // Ici, la liste des fiches pratiques
            const sheetList = action.sheets.map((sheet) => ({sheet})).sort((a, b) => a - b);
            return {
                ...state,
                sheetsList: sheetList,
                searchSheet: action.sheets,
                firstsSheetsOfArray: firstsSheetsOfArray
            };
        }
        case SEARCH_SHEETS : {
            const {sheetsValue} = action;
            // Valeur entré par le user dans la barre de recherche
            const searchSheetsValue = sheetsValue.toLowerCase();
            // On cherche filtre le tableau des fiches pratique grâce à la valeur entrée par le user
            const searchSheet = state.sheetsList.filter((sheet) => sheet.titre.toLowerCase().includes(searchSheetsValue));

            return {
                ...state,
                searchSheetValue: searchSheetsValue,
                searchSheet: searchSheet
            };
        }
        default:
            return state;
    }
};

export default sheets;